import { Component, Input, OnInit } from '@angular/core';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss']
})
export class DialogHeaderComponent implements OnInit {
  /** @deprecated use headerKey*/
  @Input() header: string = '';

  @Input() headerKey: string | LocLabel = '';
  @Input() showCloseButton: boolean = true;
  constructor() {}

  ngOnInit(): void {}
}
